import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=4b26d376"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"
import style0 from "./Game.vue?vue&type=style&index=0&id=4b26d376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports